module.exports = {"533401101":"建塘镇","533401102":"小中甸镇","533401103":"虎跳峡镇","533401104":"金江镇","533401201":"上江乡","533401202":"三坝乡","533401203":"洛吉乡","533401204":"尼西乡","533401205":"格咱乡","533401206":"东旺乡","533401207":"五境乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/533401.json
// module id = 2479
// module chunks = 0